import { h } from 'preact'
import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Post = (props) => {

  let post = props.post
  let title = post.title.rendered
  let link = post.link
  let feat_image = post.feat_image
  let branches = post.project_branch_names.join(', ')
  let services = post.project_service_names.join(' &middot; ')
  let locations = post.project_location_names.join(', ')
  let company = post.project_company
  let raw_date = post.date
  let date = Moment(raw_date).format('DD-MM-YYYY')

  return (
    <a href={link} className="c-project c-projects__col">

      <div className="c-project__image u-image">
        <div dangerouslySetInnerHTML={{ __html: feat_image }} />

        <div
          className="c-project__company"
          dangerouslySetInnerHTML={{ __html: company }}
        />
      </div>

      <div className="c-project__content u-flex">

        <div className="c-project__header u-flex u-flex-sb">
          <div className="c-project__branches" dangerouslySetInnerHTML={{ __html: branches }} />
          <div className="c-project__date">{date}</div>
        </div>

        <div className="c-project__body">
          <h3 className="c-project__title">
            <span className="c-project__name" dangerouslySetInnerHTML={{ __html: title }} />
            { locations ? ( <span className="c-project__comma">, </span> ) : null }
            <span className="c-project__locations" dangerouslySetInnerHTML={{ __html: locations }} />
          </h3>

          <div className="c-project__services" dangerouslySetInnerHTML={{ __html: services }} />
        </div>

        <div className="c-project__footer">
          <div className="c-button c-project__button">
            Bekijk project
            <svg class="c-icon c-button__icon c-button__icon--right c-project__icon">
              <use href="#circle-arrow-right" xlinkHref="#circle-arrow-right"></use>
            </svg>
          </div>
        </div>

      </div>

    </a>
  )
}

export default Post



// WEBPACK FOOTER //
// ./src/js/projects/components/Post.js